import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';
import { Incident } from './useIncidents';

export type PendingIncident = Incident;

export function usePendingReview() {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [incidents, setIncidents] = useState<PendingIncident[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<{ incidents?: PendingIncident[] }>('/api/dashboard/incidents?status=pending_review', token)
      .then((d) => { if (!cancelled) { setIncidents(d.incidents || []); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, refreshKey, logout]);

  return { incidents, loading };
}
